<toast-notification #toastNotification></toast-notification>

  <div class="acs-row acs-row--gap-lg acs-split">
    <!-- Table Panel -->
    <div class="acs-col--full acs-split__list">
      <!-- Toolbar -->
      <div class="acs-toolbar">
        <div class="acs-flex acs-flex--center acs-gap-sm">
          <div class="acs-flex acs-flex--center">
            <i class="fa-solid fa-building acs-dropdown__icon" title="Trade Unit / Group"></i>
            <div class="acs-dropdown" (click)="$event.stopPropagation()">
            <button type="button" class="acs-dropdown__trigger" (click)="locDropdown.toggle()"
                    [class.acs-dropdown__trigger--placeholder]="!locDropdown.selectedValue">
              {{locDropdown.displayText}}
              <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
            </button>
            <div class="acs-dropdown__panel" *ngIf="locDropdown.isOpen()">
              <input class="acs-dropdown__search" type="text" placeholder="Search..."
                     [ngModel]="locDropdown.searchText()" (ngModelChange)="locDropdown.searchText.set($event)"
                     (click)="$event.stopPropagation()" />
              <div class="acs-dropdown__options">
                <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                     (click)="selectLocOption(null)">-- Select Trade Unit --</div>
                <div *ngFor="let loc of locDropdown.filtered"
                     class="acs-dropdown__option"
                     [class.acs-dropdown__option--selected]="loc.value === locDropdown.selectedValue"
                     (click)="selectLocOption(loc)">{{loc.text}}</div>
                <div *ngIf="locDropdown.filtered.length === 0" class="acs-dropdown__empty">No matches</div>
              </div>
            </div>
          </div>
          </div>
          <div class="acs-flex acs-flex--center">
            <i class="fa-solid fa-wheat-awn acs-dropdown__icon" title="Commodity"></i>
            <div class="acs-dropdown acs-dropdown--compact" (click)="$event.stopPropagation()">
              <button type="button" class="acs-dropdown__trigger" (click)="toggleCommodityFilterDropdown()"
                      [class.acs-dropdown__trigger--placeholder]="!selectedCommodityFilter">
                {{commodityFilterDisplay}}
                <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
              </button>
              <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('vw-commodity-filter')">
                <input class="acs-dropdown__search" type="text" placeholder="Search..."
                       [ngModel]="commodityFilterSearchText()" (ngModelChange)="commodityFilterSearchText.set($event)"
                       (click)="$event.stopPropagation()" />
                <div class="acs-dropdown__options">
                  <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                       (click)="selectCommodityFilterOption(null)">-- All Commodities --</div>
                  <div *ngFor="let v of filteredCommodityFilterOptions"
                       class="acs-dropdown__option"
                       [class.acs-dropdown__option--selected]="v === selectedCommodityFilter"
                       (click)="selectCommodityFilterOption(v)">{{v}}</div>
                  <div *ngIf="filteredCommodityFilterOptions.length === 0" class="acs-dropdown__empty">No matches</div>
                </div>
              </div>
            </div>
          </div>
          <div class="acs-flex acs-flex--center">
            <i class="fa-solid fa-globe acs-dropdown__icon" title="Country"></i>
            <div class="acs-dropdown acs-dropdown--compact" (click)="$event.stopPropagation()">
              <button type="button" class="acs-dropdown__trigger" (click)="toggleCountryFilterDropdown()"
                      [class.acs-dropdown__trigger--placeholder]="!selectedCountryFilter">
                {{countryFilterDisplay}}
                <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
              </button>
              <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('vw-country-filter')">
                <input class="acs-dropdown__search" type="text" placeholder="Search..."
                       [ngModel]="countryFilterSearchText()" (ngModelChange)="countryFilterSearchText.set($event)"
                       (click)="$event.stopPropagation()" />
                <div class="acs-dropdown__options">
                  <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                       (click)="selectCountryFilterOption(null)">-- All Countries --</div>
                  <div *ngFor="let v of filteredCountryFilterOptions"
                       class="acs-dropdown__option"
                       [class.acs-dropdown__option--selected]="v === selectedCountryFilter"
                       (click)="selectCountryFilterOption(v)">{{v}}</div>
                  <div *ngIf="filteredCountryFilterOptions.length === 0" class="acs-dropdown__empty">No matches</div>
                </div>
              </div>
            </div>
          </div>
          <div class="acs-flex acs-flex--center">
            <i class="fa-solid fa-map-pin acs-dropdown__icon" title="State"></i>
            <div class="acs-dropdown acs-dropdown--compact" (click)="$event.stopPropagation()">
              <button type="button" class="acs-dropdown__trigger" (click)="toggleStateFilterDropdown()"
                      [class.acs-dropdown__trigger--placeholder]="!selectedStateFilter">
                {{stateFilterDisplay}}
                <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
              </button>
              <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('vw-state-filter')">
                <input class="acs-dropdown__search" type="text" placeholder="Search..."
                       [ngModel]="stateFilterSearchText()" (ngModelChange)="stateFilterSearchText.set($event)"
                       (click)="$event.stopPropagation()" />
                <div class="acs-dropdown__options">
                  <div class="acs-dropdown__option acs-dropdown__option--placeholder"
                       (click)="selectStateFilterOption(null)">-- All States --</div>
                  <div *ngFor="let v of filteredStateFilterOptions"
                       class="acs-dropdown__option"
                       [class.acs-dropdown__option--selected]="v === selectedStateFilter"
                       (click)="selectStateFilterOption(v)">{{v}}</div>
                  <div *ngIf="filteredStateFilterOptions.length === 0" class="acs-dropdown__empty">No matches</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="acs-toolbar__actions">
          <small *ngIf="weightDefaults.length > 0" class="acs-text-muted">{{filteredDefaults.length}} of {{weightDefaults.length}} default(s)</small>
          <button type="button" class="acs-action-btn acs-action-btn--danger"
                  [disabled]="bulkDelete.selectedCount === 0"
                  (click)="bulkDelete.requestDelete()">
            <i class="fa-solid fa-trash"></i> Delete<span *ngIf="bulkDelete.selectedCount > 0"> ({{bulkDelete.selectedCount}})</span>
          </button>
          <button type="button" class="acs-action-btn acs-action-btn--accent"
                  (click)="addDefault()" [disabled]="isAllMode">
            <i class="fa-solid fa-plus"></i> Add Default
          </button>
        </div>
      </div>

      <!-- Table -->
      <div class="acs-table-wrap acs-table-wrap--connected acs-split__list__table">
        <table class="acs-table acs-table--striped acs-table--hover acs-table--bordered">
          <thead class="acs-thead--primary acs-sticky">
            <tr>
              <th class="acs-table__checkbox-col">
                <input type="checkbox" class="acs-table__checkbox"
                       [checked]="bulkDelete.allVisibleSelected && selectableDefaults.length > 0"
                       (change)="bulkDelete.toggleSelectAll()">
              </th>
              <th>Loc/Group</th>
              <th>Commodity</th>
              <th>Country</th>
              <th>State</th>
              <th>Qty/Truck</th>
              <th>UOM</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredDefaults"
                (click)="selectItem(item)" class="acs-cursor-pointer"
                [class.acs-tr--active]="selectedItem?.commLoadWtDefaultId === item.commLoadWtDefaultId"
                [class.acs-bold]="selectedItem?.commLoadWtDefaultId === item.commLoadWtDefaultId">
              <td class="acs-table__checkbox-col" (click)="$event.stopPropagation()">
                <input *ngIf="item.locCode !== ACS_WILDCARD" type="checkbox" class="acs-table__checkbox"
                       [checked]="bulkDelete.isSelected(item.commLoadWtDefaultId)"
                       (change)="bulkDelete.toggle(item.commLoadWtDefaultId, $event)">
              </td>
              <td>{{item.locCode}}</td>
              <td>{{item.commodityCode}}</td>
              <td>{{item.countryCode}}</td>
              <td>{{item.stateCode}}</td>
              <td class="text-end">{{formatQuantity(item.defaultWeight)}}</td>
              <td>{{item.uom}}</td>
            </tr>
            <tr *ngIf="filteredDefaults.length === 0">
              <td colspan="7" class="acs-empty-cell">No weight defaults found.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Detail Modal -->
    <div *ngIf="showForm" class="acs-modal" tabindex="-1">
      <div class="acs-modal__dialog">
        <div class="acs-modal__content">
          <div class="acs-modal__header">
            <h6 class="acs-modal__title">{{isNewRecord ? 'New Weight Default' : 'Edit Weight Default'}}</h6>
            <button type="button" class="acs-btn--close" (click)="closeForm()">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
          <div class="acs-modal__body">
            <div class="acs-row acs-mb-2">
              <div class="acs-col--md6">
                <label class="acs-label">Trade Unit / Group *</label>
                <input *ngIf="!isNewRecord" type="text" class="acs-input" [value]="formLocDisplay" readonly>
                <div *ngIf="isNewRecord" class="acs-dropdown acs-dropdown--full" (click)="$event.stopPropagation()">
                  <button type="button" class="acs-dropdown__trigger" (click)="toggleFormLocDropdown()"
                          [class.acs-dropdown__trigger--placeholder]="!formLocCode">
                    {{formLocDisplay}}
                    <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
                  </button>
                  <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('vw-form-loc')">
                    <input class="acs-dropdown__search" type="text" placeholder="Search trade unit..."
                           [ngModel]="formLocSearchText()" (ngModelChange)="formLocSearchText.set($event)"
                           (click)="$event.stopPropagation()" />
                    <div class="acs-dropdown__options">
                      <div *ngFor="let loc of filteredFormLocOptions"
                           class="acs-dropdown__option"
                           [class.acs-dropdown__option--selected]="loc.value === formLocCode"
                           (click)="selectFormLoc(loc)">{{loc.text}}</div>
                      <div *ngIf="filteredFormLocOptions.length === 0" class="acs-dropdown__empty">No matches</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="acs-col--md6">
                <label class="acs-label">Commodity *</label>
                <input *ngIf="isWildcardRow" type="text" class="acs-input"
                       [value]="formCommodityCode === '*' ? '* - All' : formCommodityCode" readonly>
                <div *ngIf="!isWildcardRow" class="acs-dropdown acs-dropdown--full" (click)="$event.stopPropagation()">
                  <button type="button" class="acs-dropdown__trigger" (click)="toggleCommodityDropdown()"
                          [class.acs-dropdown__trigger--placeholder]="!formCommodityCode">
                    {{selectedCommodityDisplay}}
                    <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
                  </button>
                  <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('vw-form-commodity')">
                    <input class="acs-dropdown__search" type="text" placeholder="Search commodity..."
                           [ngModel]="commoditySearchText()" (ngModelChange)="commoditySearchText.set($event)"
                           (click)="$event.stopPropagation()" />
                    <div class="acs-dropdown__options">
                      <div *ngFor="let c of filteredCommodities"
                           class="acs-dropdown__option"
                           [class.acs-dropdown__option--selected]="c.commodityCode === formCommodityCode"
                           (click)="selectCommodity(c)">
                        {{c.commodityCode}} - {{c.description || c.shortDescription || ''}}
                      </div>
                      <div *ngIf="filteredCommodities.length === 0" class="acs-dropdown__empty">No matches</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="acs-row acs-mb-2">
              <div class="acs-col--md6">
                <label class="acs-label">Country *</label>
                <input *ngIf="isWildcardRow" type="text" class="acs-input"
                       [value]="formCountryCode === '*' ? '* - All' : formCountryCode" readonly>
                <div *ngIf="!isWildcardRow" class="acs-dropdown acs-dropdown--full" (click)="$event.stopPropagation()">
                  <button type="button" class="acs-dropdown__trigger" (click)="toggleCountryDropdown()"
                          [class.acs-dropdown__trigger--placeholder]="!formCountryCode">
                    {{selectedCountryDisplay}}
                    <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
                  </button>
                  <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('vw-form-country')">
                    <input class="acs-dropdown__search" type="text" placeholder="Search country..."
                           [ngModel]="countrySearchText()" (ngModelChange)="countrySearchText.set($event)"
                           (click)="$event.stopPropagation()" />
                    <div class="acs-dropdown__options">
                      <div *ngFor="let c of filteredCountryOptions"
                           class="acs-dropdown__option"
                           [class.acs-dropdown__option--selected]="c.code === formCountryCode"
                           (click)="selectCountry(c)">{{c.code}} - {{c.name}}</div>
                      <div *ngIf="filteredCountryOptions.length === 0" class="acs-dropdown__empty">No matches</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="acs-col--md6">
                <label class="acs-label">State / Province *</label>
                <input *ngIf="isWildcardRow" type="text" class="acs-input"
                       [value]="formStateCode === '*' ? '* - All' : formStateCode" readonly>
                <div *ngIf="!isWildcardRow" class="acs-dropdown acs-dropdown--full" (click)="$event.stopPropagation()">
                  <button type="button" class="acs-dropdown__trigger" (click)="toggleStateDropdown()"
                          [class.acs-dropdown__trigger--placeholder]="!formStateCode">
                    {{selectedStateDisplay}}
                    <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
                  </button>
                  <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('vw-form-state')">
                    <input class="acs-dropdown__search" type="text" placeholder="Search state..."
                           [ngModel]="stateSearchText()" (ngModelChange)="stateSearchText.set($event)"
                           (click)="$event.stopPropagation()" />
                    <div class="acs-dropdown__options">
                      <div *ngFor="let s of filteredStateOptions"
                           class="acs-dropdown__option"
                           [class.acs-dropdown__option--selected]="s.stateCode === formStateCode"
                           (click)="selectState(s)">{{s.stateCode}} - {{s.stateName}}</div>
                      <div *ngIf="filteredStateOptions.length === 0" class="acs-dropdown__empty">No matches</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="acs-row acs-mb-2">
              <div class="acs-col--md6">
                <label class="acs-label">Qty / Truck *</label>
                <input type="number" class="acs-input" [(ngModel)]="formQuantity"
                       placeholder="e.g. 1000" step="1"
                       (blur)="formQuantity = formQuantity !== null ? Math.floor(formQuantity) : null">
              </div>
              <div class="acs-col--md6">
                <label class="acs-label">UOM *</label>
                <input *ngIf="isWildcardRow || isUomReadOnly" type="text" class="acs-input" [value]="formUom" readonly>
                <div *ngIf="!isWildcardRow && !isUomReadOnly" class="acs-dropdown acs-dropdown--full" (click)="$event.stopPropagation()">
                  <button type="button" class="acs-dropdown__trigger" (click)="toggleUomDropdown()"
                          [class.acs-dropdown__trigger--placeholder]="!formUom">
                    {{selectedUomDisplay}}
                    <i class="fa-solid fa-chevron-down acs-dropdown__arrow"></i>
                  </button>
                  <div class="acs-dropdown__panel" *ngIf="dropdowns.isOpen('vw-form-uom')">
                    <input class="acs-dropdown__search" type="text" placeholder="Search UOM..."
                           [ngModel]="uomSearchText()" (ngModelChange)="uomSearchText.set($event)"
                           (click)="$event.stopPropagation()" />
                    <div class="acs-dropdown__options">
                      <div *ngFor="let u of filteredUomList"
                           class="acs-dropdown__option"
                           [class.acs-dropdown__option--selected]="u === formUom"
                           (click)="selectUom(u)">{{u}}</div>
                      <div *ngIf="filteredUomList.length === 0" class="acs-dropdown__empty">No matches</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="acs-modal__footer">
            <button class="acs-btn acs-btn--secondary" (click)="closeForm()" [disabled]="isSaving">Cancel</button>
            <button class="acs-btn acs-btn--primary" (click)="saveDefault()" [disabled]="isSaving">
              {{isSaving ? 'Saving...' : (isNewRecord ? 'Save' : 'Update')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- Delete Confirmation Modal -->
<div *ngIf="bulkDelete.showConfirm" class="acs-modal" tabindex="-1">
  <div class="acs-modal__dialog acs-modal__dialog--sm">
    <div class="acs-modal__content">
      <div class="acs-modal__header">
        <h6 class="acs-modal__title">Confirm Delete</h6>
        <button type="button" class="acs-btn--close" (click)="bulkDelete.cancelDelete()" [disabled]="bulkDelete.isDeleting">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div class="acs-modal__body">
        <p>Delete <strong>{{bulkDelete.selectedCount}}</strong> weight default(s)? This action cannot be undone.</p>
      </div>
      <div class="acs-modal__footer">
        <button class="acs-btn acs-btn--secondary" (click)="bulkDelete.cancelDelete()" [disabled]="bulkDelete.isDeleting">Cancel</button>
        <button class="acs-btn acs-btn--danger" (click)="confirmBulkDelete()" [disabled]="bulkDelete.isDeleting">
          {{bulkDelete.isDeleting ? 'Deleting...' : 'Yes, Delete'}}
        </button>
      </div>
    </div>
  </div>
</div>
